import type { FC } from 'react';
import React, { useMemo } from 'react';

import { requestCallback } from 'Services/api/payment';
import { useBraze } from 'Services/braze';
import { sendBrazeMotorwayMoveEvent } from 'Services/braze/brazeEvents';
import useUser from 'Utilities/hooks/useUser';

import DiscoverMWMove from './DiscoverMWMove';
import type { DiscoverMWMoveProps } from './DiscoverMWMove.types';

export const DiscoverMWMovePage: FC = () => {
	useBraze({ eventFn: sendBrazeMotorwayMoveEvent });

	const { isLoggedOut } = useUser();

	const resolveDisplayAs = useMemo((): DiscoverMWMoveProps['displayAs'] => {
		return isLoggedOut ? 'signedOut' : 'signedIn';
	}, [isLoggedOut]);

	return <DiscoverMWMove displayAs={resolveDisplayAs} requestCallbackCallback={requestCallback} />;
};
